import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import Banner from "./Banner";
import Notice from "./Notice";
import Why from "./Why";
import News from "./News";
import Trade from "./Trade";
import Feature from "./Feature";
import Question from "./Question";
import Form from "./Form";

const DesktopHome = observer(() => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const {
    authStore: { banners, top_coin, logo, authenticated },
  } = useStores();

  return (
    <main className="ease-soft-in-out relative h-screen transition-all duration-200 bg-[#13111a] dark:bg-[#13111a]">
      <div className="w-full h-full">
        <div className="relative w-full mx-auto overflow-auto ">
          <div className="fixed z-20 top-0 left-0 w-full flex items-center justify-between px-6 py-3 bg-[#13111a]">
            <a className="z-20" href="/">
              <img className="w-auto h-[52px]" src={logo} alt="codex" />
            </a>
            <div className="hidden lg:flex items-center justify-center">
              <Link className="py-4 px-5 font-semibold text-[#fff]" to="/board">
                <span>Home</span>
              </Link>
              <a className="py-4 px-5 font-semibold text-[#fff]" href="/#">
                <span>Features</span>
              </a>
              <a className="py-4 px-5 font-semibold text-[#fff]" href="/#">
                <span>About</span>
              </a>
              <a className="py-4 px-5 font-semibold text-[#fff]" href="/#">
                <span>Review</span>
              </a>
              <a className="py-4 px-5 font-semibold text-[#fff]" href="/#">
                <span>Help</span>
              </a>
            </div>
            <Link
              className="relative group flex items-center justify-center cursor-pointer "
              to="/m"
            >
              <div className="absolute top-0 left-0 group-hover:top-[5px] group-hover:left-[5px] bg-[#fff] duration-300 ease-in-out w-full h-full" />
              <div className="relative text-[#000] bg-[#f7a600] px-8 py-[10px] font-bold">
                Get started
              </div>
            </Link>
          </div>
          <Banner />
          <Notice />
          <Why />
          <News />
          <Trade />
          <Feature />
          <Question />
          <Form />
          <div className=" relative py-[35px]  mx-auto max-full lg:max-w-[1140px] 2xl:max-w-[1320px] px-6 hero-animate h-[150px]">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <span className="text-[#fff] opacity-60">
                  © Copyright 2014, All Rights Reserved by EUREX
                </span>
              </div>
              <ul className="flex items-center justify-end gap-2">
                <li>
                  <a
                    className="text-[#fff] opacity-60 hover:opacity-100"
                    href="/m"
                  >
                    <span>Terms</span>
                  </a>
                </li>
                <div className="w-[4px] h-[4px] rounded-[100%] bg-[#fff] " />
                <li>
                  <a
                    className="text-[#fff] opacity-60 hover:opacity-100"
                    href="/m"
                  >
                    <span>Privacy Policy</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
});

export default DesktopHome;
